import React from 'react';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const MachineNameSelection = (props) => {
  const { title, onBack, onNext, selectedMachineName, setSelectedMachineName } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>{title}</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>Machine name can not be longer than 8 characters, FYI</p>
          <TextField
            required
            id="machine-name"
            label="Machine Name"
            onChange={(event) => {
              setSelectedMachineName(event.target.value);
            }}
            sx={{ width: '300px' }}
            value={selectedMachineName ?? ''}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !selectedMachineName,
          })}
          disabled={!selectedMachineName}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default MachineNameSelection;
